import { COMMON } from '@/configs/main.config';
import { SipJs } from '@/services/sip-js.service';
import { State } from '@/services/state.service';
import { IEntity } from '../interfaces/entity.interface';

export const commonMakeCall = (
  entities: IEntity[],
  initialPhone: string,
  allowSecondCall?: boolean,
) => {
  const sipPhone = validatePhoneNumber(initialPhone);

  if (!entities?.length) {
    entities = [
      {
        ...COMMON.UNKNOWN_ENTITY,
        initialPhone,
      },
    ];
  }

  State.setState({ activeEntities: entities });
  SipJs.makeCall(sipPhone, allowSecondCall);
};

export const validatePhoneNumber = (phone: string): string => {
  // Retrieve the phone number to dial from parameters passed by CIF and remove any non-numerics
  const sipPhone = phone.replace(/[^0-9*#]/g, '');

  // Note: asked for removing adding "+", it will be added on PortSIP
  // Internationalise the number if necessary
  // if (sipPhone.substring(0, 1) != '0' && sipPhone.substring(0, 2) != '00' && sipPhone.length > 10) {
  //     sipPhone = `${MAIN.phone_prefix}${sipPhone}`;
  // }

  return sipPhone;
};
